export default "__VITE_ASSET__CeRlzqt$__"